<template>
  <div class="instruction-content">
    <router-link class="instruction-content-btn" :to="{ name: 'instruction', params: { type: device }}"> {{ $t('Korzyna App') }} </router-link>
    <img
      src="../../assets/instruction/icon-phone.svg"
      class="instruction-content-image"
      alt="Phone"
      width="88"
      height="125"
      loading="lazy"
      fetchpriority="auto"
    >
  </div>
</template>

<script>
export default {
  name: 'InstructionRedirect',
  props: {
    device: {
      type: String,
      require: true,
      default: 'android'
    }
  }
}
</script>

<style scoped lang="scss">
  @keyframes gradient-animation {
    0% { transform: translate(-5%, 0) }
    50% { transform: translate(-45.5%, -50%) }
    100% { transform: translate(-5%, 0) }
  }

  .instruction-content {
    margin-top: 30px;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    &-btn {
      position: relative;
      z-index: 0;
      overflow: hidden;
      padding: 12px 20px 12px 40px;

      color: #fff;
      font-size: 14px;
      font-weight: 600;

      border: none;
      border-radius: 10px;
      transition: .2s;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 200%;
        height: 200%;
        background: linear-gradient(-130deg, rgba(137,255,0,1), rgba(208,172,51,1), rgba(255,115,85,1));
        animation: gradient-animation 3s cubic-bezier(.77, 0, .175, 1) infinite;
      }
    }

    &-image {
      width: 14px;
      height: 20px;

      position: absolute;
      top: 0;
      right: 0;
      left: -130px;
      bottom: 0;
      margin: auto;

      z-index: 2;
    }
  }
</style>
